/**
 * =====================================
 * File: Buttons.js
 * Component: BlockButton
 * Purpose: Create a set of reusable button components
 * Author: Noah Fultz
 * Date: 2026-06-20
 * =====================================
 */

import { Link } from 'react-router-dom'

import './Buttons.css';


function BlockButton({
  type = 'internal',
  to, href, target = '_blank',
  width = 'auto', height = 'auto',
  onClick = () => { },
  children
}) {
  return (<div className='blockbutton-link' style={{ width: width, height: height }}>
    {/* This is the section that links to pages external to the site */}
    { type === 'external' &&
      <a
        href={href}
        target={target}
        rel='noopener noreferrer'
        onClick={onClick}
      >{children}</a>}

    {/* This is the section that links to pages internal to the site */}
    { type === 'internal' &&
      <Link to={to} onClick={onClick}>{children}</Link>}
  </div>)
}



function BarButton({
  type = 'internal',
  to, href, target = '_blank',
  width = 'auto', height = 'auto',
  onClick = () => { },
  children
}) {
  return (<div className='barbutton-link' style={{ width: width, height: height }}>
    {/* This is the section that links pages to external to the site */}
    { type === 'external' &&
      <a
        href={href}
        target={target}
        rel='noopener noreferrer'
        onClick={onClick}
      >{children}</a> }

    {/* This is the section that links to pages internal to the site */}
    {type === 'internal' &&
      <Link to={to} onClick={onClick}>{children}</Link>}
  </div>)
}


export {
  BlockButton,
  BarButton
}